module.exports = __webpack_public_path__ + "img/fire_orange.01a3ff4c.gif";